import React from 'react';
import { MDBBtn, MDBBtnGroup } from 'mdb-react-ui-kit';
import LitePaper from '../Downloads/h.Society_Litepaper.pdf';
import Roadmap from '../Downloads/h.Society_Roadmap.pdf';

const Downloads = ({className}) => {
  return (
    <div className={`text-center mx-5 pt-2 ${className}`}>
      <MDBBtnGroup aria-label='Download Buttons'>
        <MDBBtn className='bgOverlay'><a className='text-white' href={LitePaper} download={LitePaper}>h.Society LitePaper V.1</a></MDBBtn>
        <MDBBtn className='bgOverlay'><a className='text-white' href={Roadmap} download={Roadmap}>h.Society RoadMap V.1</a></MDBBtn>
      </MDBBtnGroup>
    </div>
  )
}

export default Downloads;